module.exports = __webpack_public_path__ + "static/img/quadrato.71e0db7.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/quadrato.png
// module id = Klpq
// module chunks = 1